export type BooxCiSetId =
  | 'flat_ops'
  | 'plush_cloud'
  | 'toy_capsule'
  | 'pixel_dispatch'
  | 'origami_route'
  | 'night_ops'
  | 'sticker_star'
  | 'yard_utility';

export type BooxIconSetId = 'lucide' | 'tabler' | 'phosphor' | 'streamline_free';

export interface VisualChoiceOption<T extends string> {
  value: T;
  label: string;
  description: string;
  recommendedFor?: string;
}

export const BOOX_CI_SET_OPTIONS: Array<VisualChoiceOption<BooxCiSetId>> = [
  { value: 'flat_ops', label: 'Flat Ops Buddy', description: 'Clean product UI mascot for the default Boox operations workspace.', recommendedFor: 'Default CI' },
  { value: 'plush_cloud', label: 'Plush Cloud Bot', description: 'Softer friendly assistant for onboarding and welcome moments.', recommendedFor: 'Onboarding' },
  { value: 'toy_capsule', label: 'Toy Capsule 3D', description: 'Modern app mascot with richer depth and stronger brand presence.', recommendedFor: 'Brand visual' },
  { value: 'pixel_dispatch', label: 'Pixel Dispatch Pal', description: 'Retro game-like persona for badges and training feedback.', recommendedFor: 'Gamification' },
  { value: 'origami_route', label: 'Origami Route Drone', description: 'Light geometric mascot for elegant route and pattern surfaces.', recommendedFor: 'Premium pattern' },
  { value: 'night_ops', label: 'Night Ops Agent', description: 'Serious AI operations assistant for power users.', recommendedFor: 'AI ops' },
  { value: 'sticker_star', label: 'Sticker Star Helper', description: 'Reward character for checklist completion and milestones.', recommendedFor: 'Rewards' },
  { value: 'yard_utility', label: 'Yard Utility Bot', description: 'Industrial field helper for trucking, yard and depot workflows.', recommendedFor: 'Yard / trucking' },
];

export const BOOX_ICON_SET_OPTIONS: Array<VisualChoiceOption<BooxIconSetId>> = [
  { value: 'lucide', label: 'Lucide', description: 'Default open-source line icon set. Best for dense professional operations screens.' },
  { value: 'tabler', label: 'Tabler Icons', description: 'MIT icon set with broad business, logistics and dashboard coverage.', recommendedFor: 'Global backup' },
  { value: 'phosphor', label: 'Phosphor Icons', description: 'MIT icon family with friendlier weights for customer-facing surfaces.', recommendedFor: 'Portal / friendly UI' },
  {
    value: 'streamline_free',
    label: 'Streamline Free',
    description: 'Free Streamline source for testing selected commercial-use icons; requires attribution and license review before production bundling.',
    recommendedFor: 'Evaluation only',
  },
];

export function resolveBooxCiSet(value?: string | null): BooxCiSetId {
  return BOOX_CI_SET_OPTIONS.some((option) => option.value === value) ? (value as BooxCiSetId) : 'flat_ops';
}

export function resolveBooxIconSet(value?: string | null): BooxIconSetId {
  if (value === 'tabler' || value === 'phosphor' || value === 'streamline_free') return value;
  return 'lucide';
}
